const teamMap = {
  1: {
    id: 10,
    full_name: "Adelaide Crows",
    name: "Adelaide Crows",
    short_name: "ADE",
    close: ["CD_T10", "CD_T110"],
    colors: ["red", "yellow", "blue"],
    state: "SA",
  },
  2: {
    id: 20,
    full_name: "Brisbane Lions",
    name: "Brisbane Lions",
    short_name: "BRL",
    close: ["CD_T20", "CD_T1000"],
    colors: ["maroon", "yellow", "blue"],
    state: "QLD",
  },
  3: {
    id: 30,
    full_name: "Carlton",
    name: "Carlton",
    short_name: "CAR",
    close: [
      "CD_T30",
      "CD_T40",
      "CD_T50",
      "CD_T70",
      "CD_T80",
      "CD_T90",
      "CD_T100",
      "CD_T120",
      "CD_T130",
      "CD_T140",
    ],
    colors: ["blue"],
    state: "VIC",
  },
  4: {
    id: 40,
    full_name: "Collingwood",
    name: "Collingwood",
    short_name: "COL",
    close: [
      "CD_T30",
      "CD_T40",
      "CD_T50",
      "CD_T70",
      "CD_T80",
      "CD_T90",
      "CD_T100",
      "CD_T120",
      "CD_T130",
      "CD_T140",
    ],
    colors: ["black", "white"],
    state: "VIC",
  },
  5: {
    id: 50,
    full_name: "Essendon",
    name: "Essendon",
    short_name: "ESS",
    close: [
      "CD_T30",
      "CD_T40",
      "CD_T50",
      "CD_T70",
      "CD_T80",
      "CD_T90",
      "CD_T100",
      "CD_T120",
      "CD_T130",
      "CD_T140",
    ],
    colors: ["red", "black"],
    state: "VIC",
  },
  6: {
    id: 60,
    full_name: "Fremantle",
    name: "Fremantle",
    short_name: "FRE",
    close: ["CD_T60", "CD_T150"],
    colors: ["purple", "white"],
    state: "WA",
  },
  8: {
    id: 70,
    full_name: "Geelong Cats",
    name: "Geelong Cats",
    short_name: "GEE",
    close: [
      "CD_T30",
      "CD_T40",
      "CD_T50",
      "CD_T70",
      "CD_T80",
      "CD_T90",
      "CD_T100",
      "CD_T120",
      "CD_T130",
      "CD_T140",
    ],
    colors: ["white", "blue"],
    state: "VIC",
  },
  7: {
    id: 1000,
    full_name: "Gold Coast Suns",
    name: "Gold Coast Suns",
    short_name: "GCS",
    close: ["CD_T20", "CD_T1000"],
    colors: ["red", "yellow"],
    state: "QLD",
  },
  9: {
    id: 1010,
    full_name: "GWS Giants",
    name: "GWS Giants",
    short_name: "GWS",
    close: ["CD_T1010", "CD_T160"],
    colors: ["grey", "orange", "white"],
    state: "NSW",
  },
  10: {
    id: 80,
    full_name: "Hawthorn",
    name: "Hawthorn",
    short_name: "HAW",
    close: [
      "CD_T30",
      "CD_T40",
      "CD_T50",
      "CD_T70",
      "CD_T80",
      "CD_T90",
      "CD_T100",
      "CD_T120",
      "CD_T130",
      "CD_T140",
    ],
    colors: ["brown", "yellow"],
    state: "VIC",
  },
  11: {
    id: 90,
    full_name: "Melbourne",
    name: "Melbourne",
    short_name: "MEL",
    close: [
      "CD_T30",
      "CD_T40",
      "CD_T50",
      "CD_T70",
      "CD_T80",
      "CD_T90",
      "CD_T100",
      "CD_T120",
      "CD_T130",
      "CD_T140",
    ],
    colors: ["red", "blue"],
    state: "VIC",
  },
  12: {
    id: 100,
    full_name: "North Melbourne",
    name: "North Melbourne",
    short_name: "NTH",
    close: [
      "CD_T30",
      "CD_T40",
      "CD_T50",
      "CD_T70",
      "CD_T80",
      "CD_T90",
      "CD_T100",
      "CD_T120",
      "CD_T130",
      "CD_T140",
    ],
    colors: ["white", "blue"],
    state: "VIC",
  },
  13: {
    id: 110,
    full_name: "Port Adelaide",
    name: "Port Adelaide",
    short_name: "PTA",
    close: ["CD_T10", "CD_T110"],
    colors: ["black", "white", "teal"],
    state: "SA",
  },
  14: {
    id: 120,
    full_name: "Richmond",
    name: "Richmond",
    short_name: "RIC",
    close: [
      "CD_T30",
      "CD_T40",
      "CD_T50",
      "CD_T70",
      "CD_T80",
      "CD_T90",
      "CD_T100",
      "CD_T120",
      "CD_T130",
      "CD_T140",
    ],
    colors: ["yellow", "black"],
    state: "VIC",
  },
  15: {
    id: 130,
    full_name: "St Kilda",
    name: "St Kilda",
    short_name: "STK",
    close: [
      "CD_T30",
      "CD_T40",
      "CD_T50",
      "CD_T70",
      "CD_T80",
      "CD_T90",
      "CD_T100",
      "CD_T120",
      "CD_T130",
      "CD_T140",
    ],
    colors: ["red", "white", "black"],
    state: "VIC",
  },
  16: {
    id: 160,
    full_name: "Sydney Swans",
    name: "Sydney Swans",
    short_name: "SYD",
    close: ["CD_T1010", "CD_T160"],
    colors: ["red", "white"],
    state: "NSW",
  },
  17: {
    id: 140,
    full_name: "Western Bulldogs",
    name: "Western Bulldogs",
    short_name: "WBD",
    close: [
      "CD_T30",
      "CD_T40",
      "CD_T50",
      "CD_T70",
      "CD_T80",
      "CD_T90",
      "CD_T100",
      "CD_T120",
      "CD_T130",
      "CD_T140",
    ],
    colors: ["red", "white", "blue"],
    state: "VIC",
  },
  18: {
    id: 150,
    full_name: "West Coast Eagles",
    name: "West Coast Eagles",
    short_name: "WCE",
    close: ["CD_T60", "CD_T150"],
    colors: ["yellow", "blue"],
    state: "WA",
  },
};

export default teamMap;
